<form [formGroup]="inputFormGroup" *ngIf="inputFormGroup">
    <ng-container *ngFor="let field of fields; let i = index">
        <ng-container *ngIf="fieldTemplates[field.field]">
            <ng-container
                    *ngTemplateOutlet="fieldTemplates[field.field].template, context: { $implicit: field, genericInput: this, formGroup: inputFormGroup, index: i }"></ng-container>
        </ng-container>

        <ng-container *ngIf="!fieldTemplates[field.field]">
            <ng-container [ngSwitch]="field.type">
                <mat-generic-date-input *ngSwitchCase="'date'"
                                        [fieldAddOnTemplates]="(fieldAddonTemplates$ | async)?.[field.field]"
                                        [field]="field"
                                        [index]="fields.length - i" class="generic-input-item"
                                        [initialValue]="initialValue?.[field.field]"
                                        [inputFormControl]="inputFormGroup.controls[field.field]"></mat-generic-date-input>

                <mat-generic-date-time-input *ngSwitchCase="'dateTime'"
                                             [fieldAddOnTemplates]="(fieldAddonTemplates$ | async)?.[field.field]"
                                             [field]="field"
                                             [index]="fields.length - i" class="generic-input-item"
                                             [initialValue]="initialValue?.[field.field]"
                                             [inputFormControl]="inputFormGroup.controls[field.field]"></mat-generic-date-time-input>

                <mat-generic-daterange-input *ngSwitchCase="'daterange'"
                                             [fieldAddOnTemplates]="(fieldAddonTemplates$ | async)?.[field.field]"
                                             [field]="field"
                                             [initialValue]="initialValue?.[field.field]"
                                             [inputFormControl]="inputFormGroup.controls[field.field]"
                                             [formGroupName]="field.field" [index]="fields.length - i"
                                             class="generic-input-item"></mat-generic-daterange-input>

                <mat-generic-select-input *ngSwitchCase="'select'" [field]="field" [index]="fields.length - i"
                                          [fieldAddOnTemplates]="(fieldAddonTemplates$ | async)?.[field.field]"
                                          [initialValue]="initialValue?.[field.field]"
                                          class="generic-input-item"
                                          [inputFormControl]="inputFormGroup.controls[field.field]"></mat-generic-select-input>

                <mat-generic-select-input *ngSwitchCase="'multiselect'"
                                          [fieldAddOnTemplates]="(fieldAddonTemplates$ | async)?.[field.field]"
                                          [field]="field"
                                          [initialValue]="initialValue?.[field.field]"
                                          [inputFormControl]="inputFormGroup.controls[field.field]"
                                          [index]="fields.length - i"
                                          class="generic-input-item"></mat-generic-select-input>

                <mat-generic-text-input *ngSwitchCase="'text'" [field]="field" [index]="fields.length - i"
                                        [fieldAddOnTemplates]="(fieldAddonTemplates$ | async)?.[field.field]"
                                        [initialValue]="initialValue?.[field.field]"
                                        class="generic-input-item"
                                        [inputFormControl]="inputFormGroup.controls[field.field]"></mat-generic-text-input>

                <mat-generic-password-input *ngSwitchCase="'password'"
                                            [fieldAddOnTemplates]="(fieldAddonTemplates$ | async)?.[field.field]"
                                            [field]="field"
                                            [index]="fields.length - i" class="generic-input-item"
                                            [initialValue]="initialValue?.[field.field]"
                                            [inputFormControl]="inputFormGroup.controls[field.field]"></mat-generic-password-input>

                <mat-generic-textarea-input *ngSwitchCase="'textarea'"
                                            [fieldAddOnTemplates]="(fieldAddonTemplates$ | async)?.[field.field]"
                                            [field]="field"
                                            [index]="fields.length - i" class="generic-input-item"
                                            [initialValue]="initialValue?.[field.field]"
                                            [inputFormControl]="inputFormGroup.controls[field.field]"></mat-generic-textarea-input>

                <mat-generic-mask-input *ngSwitchCase="'mask'"
                                        [fieldAddOnTemplates]="(fieldAddonTemplates$ | async)?.[field.field]"
                                        [field]="field"
                                        [index]="fields.length - i" class="generic-input-item"
                                        [initialValue]="initialValue?.[field.field]"
                                        [inputFormControl]="inputFormGroup.controls[field.field]"></mat-generic-mask-input>

                <mat-generic-number-input *ngSwitchCase="'number'"
                                          [fieldAddOnTemplates]="(fieldAddonTemplates$ | async)?.[field.field]"
                                          [field]="field"
                                          [index]="fields.length - i" class="generic-input-item"
                                          [initialValue]="initialValue?.[field.field]"
                                          [inputFormControl]="inputFormGroup.controls[field.field]"></mat-generic-number-input>

                <mat-generic-decimal-input *ngSwitchCase="'decimal'"
                                           [fieldAddOnTemplates]="(fieldAddonTemplates$ | async)?.[field.field]"
                                           [field]="field"
                                           [index]="fields.length - i" class="generic-input-item"
                                           [initialValue]="initialValue?.[field.field]"
                                           [inputFormControl]="inputFormGroup.controls[field.field]"></mat-generic-decimal-input>

                <mat-generic-checkbox-input *ngSwitchCase="'checkbox'"
                                            [fieldAddOnTemplates]="(fieldAddonTemplates$ | async)?.[field.field]"
                                            [field]="field"
                                            [index]="fields.length - i" class="generic-input-item"
                                            [initialValue]="initialValue?.[field.field]"
                                            [inputFormControl]="inputFormGroup.controls[field.field]"></mat-generic-checkbox-input>

                <mat-generic-tri-checkbox-input *ngSwitchCase="'tricheckbox'"
                                                [fieldAddOnTemplates]="(fieldAddonTemplates$ | async)?.[field.field]"
                                                [field]="field"
                                                [initialValue]="initialValue?.[field.field]"
                                                [index]="fields.length - i" class="generic-input-item"
                                                [inputFormControl]="inputFormGroup.controls[field.field]"></mat-generic-tri-checkbox-input>
            </ng-container>
        </ng-container>
    </ng-container>
</form>
